import * as React from "react";
import styled from "styled-components";
import posed, { PoseGroup } from "react-pose";
import { Meta } from "./Typo";
import { Icon } from "../../../elements";

const HEIGHT = 105;

const Base = styled.div`
  padding: 6px 10px;
  display: flex;
  flex-direction: column;
  height: ${HEIGHT}px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
`;

const TopSection = styled.div`
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
`;

const TopLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1 1 auto;
`;

const TopRight = styled.div`
  margin-left: 16px;
`;

const BottomSection = styled.div``;

const HoverButton = ({ text }: { text: string }) => {
  return (
    <Meta style={{ paddingBottom: 2 }}>
      {text}
      <Icon name="right" size={10} c={["grey", 5]} style={{ marginLeft: 3 }} />
    </Meta>
  );
};

const BottomSectionContainer = posed(styled.div`
  display: flex;
  align-items: flex-end;
`)({
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 500,
      damping: 50
    }
  },
  exit: {
    opacity: 0,
    y: "100%",
    transition: {
      type: "spring",
      stiffness: 500,
      damping: 50
    }
  }
});

const BottomLeft = styled.div`
  flex: 1 1 auto;
`;

const BottomRight = styled.div`
  margin-left: 16px;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  topLeft?: React.ReactNode;
  topRight?: React.ReactNode;
  bottomLeft?: React.ReactNode;
  bottomRight?: React.ReactNode;
  HoverButtonText?: string | false | null;
  isOver?: boolean;
};

function Bottom(
  {
    style,
    className,
    topLeft,
    topRight,
    bottomLeft,
    bottomRight,
    HoverButtonText,
    isOver
  }: Props,
  ref: any
) {
  return (
    <Base ref={ref} style={style} className={className}>
      <TopSection>
        <TopLeft>{topLeft}</TopLeft>
        {topRight && <TopRight>{topRight}</TopRight>}
      </TopSection>
      <BottomSection>
        <PoseGroup>
          {!isOver || !HoverButtonText ? (
            <BottomSectionContainer key="true">
              <BottomLeft>{bottomLeft}</BottomLeft>
              {bottomRight && <BottomRight>{bottomRight}</BottomRight>}
            </BottomSectionContainer>
          ) : (
            <BottomSectionContainer key="false">
              {<HoverButton text={HoverButtonText} />}
            </BottomSectionContainer>
          )}
        </PoseGroup>
      </BottomSection>
    </Base>
  );
}

export default React.forwardRef(Bottom);
